import { useLingui } from '@lingui/react'

import { Box, Divider, Stack, Typography } from '@mui/material'

import colors from '@/assets/scss/_themes-vars.module.scss'

import TabPanel, { TabPanelProps } from '@/components/ui/tab/TabPanel'

export function ConfigurationTabPanel({ children, title, subtitle, ...rest }: TabPanelProps & { title: string; subtitle?: string }) {
  useLingui()
  return (
    <TabPanel {...rest} sx={{ height: '100%' }}>
      <Stack height="100%">
        <Stack px={4} py={2}>
          <Typography variant="h6" sx={{ color: colors.gray900, fontSize: '18px', fontWeight: 500, lineHeight: '24px', mb: '4px' }}>
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="subtitle1" sx={{ color: colors.gray500, fontSize: '14px', lineHeight: '20px' }}>
              {subtitle}
            </Typography>
          )}
        </Stack>
        <Divider />
        <Box flex={1} p={4}>
          {children}
        </Box>
      </Stack>
    </TabPanel>
  )
}
